import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const MoreVertIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M9.9974 4.16646V4.1748M9.9974 9.9998V10.0081M9.9974 15.8331V15.8415M9.9974 4.9998C9.77638 4.9998 9.56442 4.912 9.40814 4.75572C9.25186 4.59944 9.16406 4.38748 9.16406 4.16646C9.16406 3.94545 9.25186 3.73349 9.40814 3.57721C9.56442 3.42093 9.77638 3.33313 9.9974 3.33313C10.2184 3.33313 10.4304 3.42093 10.5867 3.57721C10.7429 3.73349 10.8307 3.94545 10.8307 4.16646C10.8307 4.38748 10.7429 4.59944 10.5867 4.75572C10.4304 4.912 10.2184 4.9998 9.9974 4.9998ZM9.9974 10.8331C9.77638 10.8331 9.56442 10.7453 9.40814 10.5891C9.25186 10.4328 9.16406 10.2208 9.16406 9.9998C9.16406 9.77878 9.25186 9.56682 9.40814 9.41054C9.56442 9.25426 9.77638 9.16646 9.9974 9.16646C10.2184 9.16646 10.4304 9.25426 10.5867 9.41054C10.7429 9.56682 10.8307 9.77878 10.8307 9.9998C10.8307 10.2208 10.7429 10.4328 10.5867 10.5891C10.4304 10.7453 10.2184 10.8331 9.9974 10.8331ZM9.9974 16.6665C9.77638 16.6665 9.56442 16.5787 9.40814 16.4224C9.25186 16.2661 9.16406 16.0541 9.16406 15.8331C9.16406 15.6121 9.25186 15.4002 9.40814 15.2439C9.56442 15.0876 9.77638 14.9998 9.9974 14.9998C10.2184 14.9998 10.4304 15.0876 10.5867 15.2439C10.7429 15.4002 10.8307 15.6121 10.8307 15.8331C10.8307 16.0541 10.7429 16.2661 10.5867 16.4224C10.4304 16.5787 10.2184 16.6665 9.9974 16.6665Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

MoreVertIcon.displayName = 'MoreVertIcon';
